var map = {
	"./cheetos.png": 2690,
	"./csv.png": 3993,
	"./doritos.png": 9051,
	"./gamesa.png": 855,
	"./inventory.svg": 6545,
	"./joy.png": 3427,
	"./list.svg": 71,
	"./login_splash.png": 2762,
	"./lost.png": 5311,
	"./quaker.png": 7838,
	"./sabritas.png": 3686,
	"./xls.png": 5970
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5853;